<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<mat-card class="section-card">
  <h2>Resource revalidation</h2>
  <p class="hint">
    After redesigning the role graph, review orphan mappings (resources attached to topics no longer on this role),
    remap them, recompute scores, run quality validation, and gap-fill coverage.
  </p>
  <div class="actions">
    <button mat-stroked-button type="button" (click)="load()" [disabled]="loading">Refresh orphans</button>
    <button mat-stroked-button type="button" (click)="recomputeScores()" [disabled]="loading">Recompute mapping scores</button>
    <mat-form-field appearance="outline" class="threshold">
      <mat-label>Publish threshold</mat-label>
      <input matInput type="number" step="0.01" [formControl]="publishThreshold" />
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="validateResources()" [disabled]="loading || publishThreshold.invalid">
      Queue quality validate
    </button>
    <button mat-stroked-button type="button" (click)="gapFillAll()" [disabled]="loading || publishThreshold.invalid">
      Gap-fill all topics
    </button>
  </div>
</mat-card>

<mat-card *ngIf="error" class="error-card">
  <p>{{ error }}</p>
</mat-card>

<mat-card class="section-card">
  <h2>Orphan mappings ({{ orphans.length }})</h2>
  <p class="empty" *ngIf="!orphans.length && !loading">No orphan topic mappings for this role.</p>
  <div class="orphan-row" *ngFor="let orphan of orphans">
    <div class="orphan-main">
      <a [href]="orphan.resourceUrl" target="_blank" rel="noopener noreferrer">{{ orphan.resourceTitle }}</a>
      <p class="meta">
        {{ orphan.skillName }} / {{ orphan.topicName }} · align {{ orphan.topicAlignmentScore | number:'1.2-2' }} ·
        score {{ orphan.recommendationScore | number:'1.2-2' }}
      </p>
      <p class="meta">{{ orphan.reason }}</p>
    </div>
    <form class="remap-form" *ngIf="remapForms.get(orphan.mappingId) as form" [formGroup]="form" (ngSubmit)="remap(orphan)">
      <mat-form-field appearance="outline">
        <mat-label>Remap to</mat-label>
        <mat-select formControlName="targetLabel">
          <mat-option *ngFor="let target of topicTargets" [value]="target.label">{{ target.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">Remap</button>
    </form>
  </div>
</mat-card>